var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_leaveType_form_newTitle"),
      widthClass: "max-1000",
      pad: "0",
      initData: _vm.LeaveTypeData,
      checkData: [
        "leave_type_name",
        "color_code",
        "sequence",
        "unit",
        "remarks",
        "leave_type_code",
        "leave_type_abbr",
        "leave_type_property_group_uuid",
        "leave_type_description",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.LeaveTypeData.leave_type_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypeNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "20",
                                      bindData:
                                        _vm.LeaveTypeData.leave_type_abbr,
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypeAbbrLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_abbr =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      type: "number",
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_sequenceLabel"
                                      ),
                                      maxlength: "255",
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 255]
                                      ),
                                      isNotRequire: "",
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.sequence,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "sequence",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.sequence",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_unitLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.Units,
                                      "item-value": "value_field",
                                      "item-text": "view_fields",
                                      filled: "",
                                      "single-line": "",
                                      "menu-props": {
                                        offsetY: true,
                                        transition: "slide-y-transition",
                                        rounded: true,
                                        contentClass: "elevation-4",
                                      },
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      dense: "",
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_unitLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.view_fields
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.view_fields
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.LeaveTypeData.unit,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.LeaveTypeData, "unit", $$v)
                                      },
                                      expression: "LeaveTypeData.unit",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_leaveTransactionPropertyGroup_form_codeLabel"
                                      ),
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      maxlength: "50",
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.leave_type_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "leave_type_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LeaveTypeData.leave_type_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.LeaveTypeData
                                          .leave_type_description,
                                      label: _vm.$t(
                                        "label_essweb_leaveType_form_descriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.LeaveTypeData.leave_type_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_leaveTypePropertyGroupLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.propertyGroup,
                                      "item-value": "uuid",
                                      "item-text":
                                        "leave_type_property_group_name",
                                      filled: "",
                                      "single-line": "",
                                      rules: _vm.$GetRules("_Require_Rules", [
                                        null,
                                      ]),
                                      dense: "",
                                      placeholder: _vm.$t(
                                        "label_essweb_leaveType_form_leaveTypePropertyGroupLabel"
                                      ),
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "no-data",
                                        fn: function () {
                                          return [_c("noContent")]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value:
                                        _vm.LeaveTypeData
                                          .leave_type_property_group_uuid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "leave_type_property_group_uuid",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LeaveTypeData.leave_type_property_group_uuid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "mrc_text_require text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_tagColorLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("SelectColor", {
                                    attrs: {
                                      items: _vm.Colors,
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.color_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "color_code",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.color_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_leaveType_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      filled: "",
                                      "single-line": "",
                                      dense: "",
                                      counter: "500",
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value: _vm.LeaveTypeData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LeaveTypeData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "LeaveTypeData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c(
                        "v-container",
                        {
                          staticClass: "mrc-grey rounded-lg",
                          attrs: { fluid: "" },
                        },
                        _vm._l(_vm.NoticeList, function (item, index) {
                          return _c(
                            "v-sheet",
                            {
                              key: index,
                              staticClass: "rounded-lg pa-0 drag mt-2 mb-2",
                            },
                            [
                              _c("v-hover", {
                                attrs: { "open-delay": "100" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var hover = ref.hover
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "pa-2 d-flex rounded-lg align-center",
                                              attrs: {
                                                elevation: hover ? 4 : 2,
                                              },
                                            },
                                            [
                                              _c("svg-icon", {
                                                staticStyle: {
                                                  "min-width": "36px",
                                                },
                                                attrs: {
                                                  size: "36",
                                                  fill: "black",
                                                  iconClass: "arrow01",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "text-body-2" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$getCommonLangValue(
                                                          item[
                                                            "leave_type_notice_point_" +
                                                              item.number
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("v-spacer"),
                                              hover
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toEditNotice(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              hover
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDeleteNotice(
                                                            item.number
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "material-icons-round",
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-3",
                  fn: function () {
                    return [
                      _c(
                        "v-card",
                        { staticClass: "pa-0", attrs: { elevation: 0 } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0" },
                            [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.headers,
                                  showNoContent: false,
                                  items: _vm.desserts,
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.holiday_type_name",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.holiday_type_name
                                            )
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.holiday_type_code",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(_vm._s(item.holiday_type_code)),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            { staticClass: "pb-0 pl-0" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "text-capitalize mb-3",
                                  attrs: {
                                    text: "",
                                    color: "primary",
                                    small: "",
                                  },
                                  on: { click: _vm.toNewMapping },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_leaveType_form_editHolidayTypeBtnLabel"
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "material-icons-round" },
                                    [_vm._v("add")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.step == _vm.curStep && _vm.curStep != 0 ? true : false,
                step: _vm.step == _vm.curStep ? false : true,
                onLoading: _vm.isLoading,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newNotice", {
              attrs: {
                show: _vm.showNewNotice,
                PropertyData: _vm.NoticePropertyData,
              },
              on: {
                close: function ($event) {
                  _vm.showNewNotice = false
                  _vm.NoticePropertyData = null
                },
                onNew: _vm.onNewNotice,
              },
            }),
            _c("editHolidayType", {
              attrs: { show: _vm.mapToDiag, PorpertyData: _vm.curPorperty },
              on: {
                editPorperty: _vm.onEditProperty,
                close: function ($event) {
                  _vm.mapToDiag = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }